import { Card } from "antd";
import { RedemptionConfig } from "types/redemption";
import { Star } from "lucide-react";

interface PointsBalanceProps {
  userCapsulePoints: number;
  redemptionConfig?: RedemptionConfig;
}

const PointsBalance: React.FC<PointsBalanceProps> = ({
  userCapsulePoints,
  // redemptionConfig,
}) => {
  return (
    <Card
      className="mb-8 shadow-sm border-0"
      style={{
        background: "linear-gradient(135deg, #f6f2ff 0%, #efe8ff 100%)",
      }}
    >
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
        <div className="flex items-center gap-6">
          <div className="bg-primary-500 p-4 rounded-full shadow-lg">
            <Star fill="white" color="white" />
          </div>
          <div>
            <div className="mb-2">
              <h2 className="text-lg font-semibold text-gray-700 mb-1">
                คุณมีคะแนนทั้งหมด
              </h2>
              <div className="flex items-baseline gap-2">
                <span className="text-4xl font-bold text-primary-500">
                  {userCapsulePoints.toLocaleString()}
                </span>
                <span className="text-lg text-gray-500">คะแนน</span>
              </div>
            </div>
          </div>
        </div>

        {/* {redemptionConfig && (
          <div className="bg-white/80 rounded-lg p-4 min-w-[280px]">
            <h3 className="font-semibold text-gray-700 mb-3">
              เงื่อนไขการใช้คะแนนเป็นส่วนลด
            </h3>
            <div className="space-y-2">
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">สูงสุด:</span>
                <span className="font-medium">
                  {redemptionConfig.maxUsagePercentage}% ต่อ 1 ออเดอร์
                </span>
              </div>
              {redemptionConfig.minOrderThreshold > 0 && (
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">ขั้นต่ำในการสั่ง:</span>
                  <span className="font-medium">
                    {redemptionConfig.minOrderThreshold} บาท
                  </span>
                </div>
              )}
            </div>
          </div>
        )} */}
      </div>
    </Card>
  );
};

export default PointsBalance;
